export const ADVICE_REQUESTS_ENDPOINT = 'advice-requests'
export const CHANCELLERIES_ENDPOINT = 'chancelleries'
export const FIELDS_OF_LAW_ENDPOINT = 'fields-of-law'
export const PARTNERS_ENDPOINT = 'partners'
export const PRODUCTS_BUSINESS_ENDPOINT = 'products-business'
export const PRODUCTS_ENDPOINT = 'products'
export const USER_AUTH_ENDPOINT = 'userauth'
export const USERS_ENDPOINT = 'users'
